import { render } from "./EditProfile.vue?vue&type=template&id=132ad588&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=132ad588&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132ad588"]])

export default __exports__